import { createSelector } from 'reselect';

import type { RootState } from '@/app/store';

const selectGameMetaState = (state: RootState) => state.gameMeta;

export const selectGameMetaItems = createSelector(selectGameMetaState, (s) => s.items);

export const selectGameMetaById = (gameId: string) =>
  createSelector(selectGameMetaItems, (items) => items[gameId]);
